import React from "react";

// Archive Globe emblem — "A" superimposed on a wireframe globe with meridians,
// used in header & favicon. Transparent background so it blends into any bg.
export const LogoMark = ({ size = 44, className = "" }) => (
  <img
    src={process.env.PUBLIC_URL + "/logo-globe.png"}
    alt="THE ARCHIVE mark"
    width={size}
    height={size}
    className={`block select-none ${className}`}
    style={{ width: size, height: size }}
    draggable={false}
  />
);

// Compact horizontal lockup: mark + wordmark for header bar.
export const LogoLockup = ({ markSize = 44, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <LogoMark size={markSize} className="shrink-0" />
    <div className="leading-none">
      <div className="font-display text-lg tracking-tight text-[#E4DFD3]">
        THE ARCHIVE
      </div>
      <div className="font-mono text-[9px] tracking-[0.3em] text-[#757065] mt-1">
        HIDDEN TRUTHS // EST. 2026
      </div>
    </div>
  </div>
);

// Big-format hero centerpiece — full elaborate seal with built-in wordmark.
// Has transparent background, so it blends into any page bg.
export const LogoFullSeal = ({ className = "", size = 280 }) => (
  <img
    src={process.env.PUBLIC_URL + "/logo-lockup.png"}
    alt="THE ARCHIVE — Hidden Truths, Est. 2026"
    width={size}
    height={size}
    className={`block select-none mix-blend-screen opacity-95 ${className}`}
    style={{ width: size, height: size }}
    draggable={false}
  />
);

export default LogoMark;
